import { Container, Grid, Stack, Typography, Button, Box } from "@mui/material";

import safeLink from "../../safeLink";
import { HeroSection } from "./styled";
import { innerHouse, outerHouse } from "./svg";

interface HeroBannerProps {
  title: string;
  strongTitle: string;
  subtitle: string;
  image: {
    src: string;
    alt: string;
  };
  cta?: {
    link: string;
    label: string;
  };
  backgroundColor: string;
  houseColor: string;
  strongTitleColor: string;
  ownership?: "owner" | "tenant";
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
  title,
  strongTitle,
  subtitle,
  image,
  cta,
  backgroundColor,
  houseColor,
  strongTitleColor,
}) => {
  return (
    <>
      <HeroSection backgroundColor={backgroundColor}>
        <Container sx={{ height: "100%" }}>
          <Grid container py={9} height="100%">
            <Grid item xs={12} md={7}>
              <Stack
                position="relative"
                zIndex={15}
                height="100%"
                justifyContent="center"
              >
                <Typography
                  variant="h1"
                  color="secondary"
                  fontSize={{ xs: 40, md: 60 }}
                  whiteSpace="pre-line"
                  // pl={3}
                >
                  {title}
                  <br />
                  <Box
                    borderRadius={15}
                    sx={{ bgcolor: strongTitleColor }}
                    ml={-3}
                    width="fit-content"
                  >
                    <Typography
                      variant="h1"
                      component="span"
                      fontSize={{ xs: 40, md: 60 }}
                      py={1}
                      px={3}
                      color="secondary"
                      whiteSpace="nowrap"
                    >
                      {strongTitle}
                    </Typography>
                  </Box>
                </Typography>
                {/* <SubtitleContainer color={color} ownership={ownership}>
                  <SubtitleList>
                    {strongTitle.map((text) => (
                      <Typography
                        whiteSpace="nowrap"
                        overflow="hidden"
                        variant="h1"
                        color="secondary"
                        fontSize={{ xs: 40, md: 60 }}
                        px={{ xs: 1, md: 0 }}
                        py={1}
                        ml={{ xs: -1, md: -3 }}
                        pl={{ md: 3 }}
                        mt={0.5}
                      >
                        {text}
                      </Typography>
                    ))}
                  </SubtitleList>
                </SubtitleContainer> */}
                <Typography
                  variant="subtitle2"
                  color="secondary"
                  fontSize={{ xs: 16, md: 20 }}
                  py={6}
                  whiteSpace={{ xs: "normal", md: "pre-line" }}
                >
                  {subtitle}
                </Typography>
                {cta ? (
                  <Stack alignItems={{ xs: "center", md: "start" }}>
                    <Button
                      variant="contained"
                      size="large"
                      {...safeLink(cta.link)}
                    >
                      {cta.label}
                    </Button>
                  </Stack>
                ) : null}
              </Stack>
            </Grid>
            <Grid item xs={12} md={5} display={{ xs: "none", md: "block" }}>
              <Box position="relative" height="100%" width="100%">
                <Box
                  component="img"
                  src={image.src}
                  position="absolute"
                  height="100%"
                  zIndex={5}
                  top={0}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
        <Box
          position="absolute"
          zIndex={{ md: 10 }}
          top={{ xs: cta ? 280 : 150, md: 0 }}
          right={{ xs: -570, md: -650 }}
          width={{ xs: 588, md: 976 }}
          height={{ xs: 561, md: 923 }}
          sx={{
            backgroundImage: innerHouse(houseColor),
            backgroundSize: "cover",
          }}
          overflow="hidden"
        ></Box>
        <Box
          position="absolute"
          zIndex={{ md: 1 }}
          top={{ xs: cta ? 230 : 100, md: -100 }}
          right={{ xs: -620, md: -750 }}
          width={{ xs: 701, md: 1202 }}
          height={{ xs: 674, md: 1149 }}
          sx={{
            backgroundImage: outerHouse(houseColor),
            backgroundSize: "cover",
          }}
        ></Box>
      </HeroSection>
    </>
  );
};
